import { Live } from '@/app/entities/Live'
import { LiveFormValues } from '@/view/pages/Conteudos/hooks/useLiveForm'
import { httpClient } from '../http/httpClient'

export interface LiveResponse {
  lives: Live[]
  total: number
  skip: number
  limit: number
  sort: string
}

export class LiveService {
  static async getAll(
    skip: number,
    limit: number,
    search?: string,
  ): Promise<LiveResponse> {
    const response = await httpClient.get('/live', {
      params: {
        skip,
        limit,
        search,
      },
    })
    return response.data
  }

  static async create(payload: LiveFormValues): Promise<Live> {
    const { data } = await httpClient.post<Live>('/live', payload)
    const liveId = data?._id

    if (payload.file && liveId) {
      const formData = new FormData()
      formData.append('file', payload.file)
      await httpClient.put(`/live/image/${liveId}`, formData)
    }

    return data
  }

  static async update(id: string, payload: LiveFormValues) {
    const { data } = await httpClient.put<Live>(`/live/${id}`, payload)

    if (payload.file) {
      const formData = new FormData()
      formData.append('file', payload.file)
      await httpClient.put(`/live/image/${id}`, formData)
    }

    return data
  }

  public static async delete(id: string) {
    await httpClient.delete(`/live/${id}`)
  }
}
